import React, { useState } from 'react';
const JobBoard = () => {
  const [jobs, setJobs] = useState([{
    id: 1,
    title: 'React Developer',
    company: 'TechCorp',
    skills: ['React', 'TypeScript', 'CSS'],
    remote: true
  }, {
    id: 2,
    title: 'Full Stack Engineer',
    company: 'DevHub',
    skills: ['Node.js', 'React', 'MongoDB'],
    remote: false
  }, {
    id: 3,
    title: 'AI Engineer',
    company: 'NeuralTech',
    skills: ['Python', 'TensorFlow', 'ML'],
    remote: true
  }]);
  const [showPostForm, setShowPostForm] = useState(false);
  const [newJob, setNewJob] = useState({
    title: '',
    company: '',
    skills: '',
    remote: false
  });
  const handlePost = e => {
    e.preventDefault();
    const skillsArray = newJob.skills.split(',').map(skill => skill.trim());
    setJobs([...jobs, {
      id: Date.now(),
      title: newJob.title,
      company: newJob.company,
      skills: skillsArray,
      remote: newJob.remote
    }]);
    setNewJob({
      title: '',
      company: '',
      skills: '',
      remote: false
    });
    setShowPostForm(false);
  };
  return <div data-id="element-97">
      <div className="flex justify-between items-center mb-4" data-id="element-98">
        <h2 className="text-xl font-bold" data-id="element-99">Developer Jobs</h2>
        <button className="bg-blue-600 hover:bg-blue-500 text-white px-3 py-1 rounded-md text-sm" onClick={() => setShowPostForm(!showPostForm)} data-id="element-100">
          {showPostForm ? 'Cancel' : 'Post Job'}
        </button>
      </div>
      {showPostForm ? <form onSubmit={handlePost} className="bg-gray-700 p-3 rounded-md mb-4" data-id="element-101">
          <div className="mb-3" data-id="element-102">
            <label className="block text-sm mb-1" data-id="element-103">Job Title</label>
            <input type="text" className="w-full bg-gray-800 border border-gray-600 rounded px-2 py-1 text-white" value={newJob.title} onChange={e => setNewJob({
          ...newJob,
          title: e.target.value
        })} required data-id="element-104" />
          </div>
          <div className="mb-3" data-id="element-105">
            <label className="block text-sm mb-1" data-id="element-106">Company</label>
            <input type="text" className="w-full bg-gray-800 border border-gray-600 rounded px-2 py-1 text-white" value={newJob.company} onChange={e => setNewJob({
          ...newJob,
          company: e.target.value
        })} required data-id="element-107" />
          </div>
          <div className="mb-3" data-id="element-108">
            <label className="block text-sm mb-1" data-id="element-109">
              Skills (comma separated)
            </label>
            <input type="text" className="w-full bg-gray-800 border border-gray-600 rounded px-2 py-1 text-white" value={newJob.skills} onChange={e => setNewJob({
          ...newJob,
          skills: e.target.value
        })} required data-id="element-110" />
          </div>
          <div className="mb-3 flex items-center" data-id="element-111">
            <input type="checkbox" id="remote" checked={newJob.remote} onChange={e => setNewJob({
          ...newJob,
          remote: e.target.checked
        })} className="mr-2" data-id="element-112" />
            <label htmlFor="remote" className="text-sm" data-id="element-113">
              Remote Position
            </label>
          </div>
          <button type="submit" className="bg-green-600 hover:bg-green-500 text-white px-3 py-1 rounded-md w-full" data-id="element-114">
            Post Job
          </button>
        </form> : <div className="space-y-3 max-h-[400px] overflow-y-auto" data-id="element-115">
          {jobs.map(job => <div key={job.id} className="bg-gray-700 p-3 rounded-md" data-id="element-116">
              <h3 className="font-bold" data-id="element-117">{job.title}</h3>
              <p className="text-sm text-gray-300" data-id="element-118">{job.company}</p>
              <div className="flex flex-wrap gap-1 mt-2" data-id="element-119">
                {job.skills.map((skill, index) => <span key={index} className="bg-gray-600 text-xs px-2 py-1 rounded" data-id="element-120">
                    {skill}
                  </span>)}
              </div>
              <div className="mt-2 text-xs" data-id="element-121">
                {job.remote ? <span className="text-green-400" data-id="element-122">Remote</span> : <span className="text-blue-400" data-id="element-123">On-site</span>}
              </div>
            </div>)}
        </div>}
    </div>;
};
export default JobBoard;